// extracted by mini-css-extract-plugin
export var gray = "_p-0";
export var lineItem = "_p-1";
export var lineItemActions = "_p-2";
export var lineItemImage = "_p-3";
export var lineItemInfo = "_p-4";
export var lineItemText = "_p-5";
export var titleRow = "_p-6";
export var warning = "_p-7";